import React, { ReactElement } from "react";

import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Footer from "./Footer";
import SolarWidget from "./shared/SolarWidget";

export default function Solar(): ReactElement {
  return (
    <div className="solar-container" style={{ color: "white" }}>
      <Container fluid>
        <Row className="custom__row full-height">
          <Col md={6} className="full-height">
            <div className="solar-left-col full-height">
              <Card className="pb-1 pt-1 px-1 full-height solar-timelapse-card">
                <h6 className="solar-panel-header">SDO 48 hour time lapse</h6>
                <div className="solar-timelapse-content">
                  <video
                    title="SDO 0193"
                    src="https://sdo.gsfc.nasa.gov/assets/img/latest/mpeg/latest_512_0193.mp4#505497"
                    width="400"
                    controls
                  />
                  <video
                    title="SDO 0304"
                    src="https://sdo.gsfc.nasa.gov/assets/img/latest/mpeg/latest_512_0304.mp4#813394"
                    width="400"
                    controls
                  />
                  <video
                    title="SDO 0171"
                    src="https://sdo.gsfc.nasa.gov/assets/img/latest/mpeg/latest_512_0171.mp4#982586"
                    width="400"
                    controls
                  />
                </div>
              </Card>
              <Row className="solar-bottom-row full-height">
                <Col md={6} className="full-height">
                  <Card className="pb-1 pt-1 px-1 full-height solar-coronal-card">
                    <Card.Body className="p-0 d-flex flex-column">
                      <Card.Title className="h6 solar-panel-header mb-0 px-2">
                        Coronal holes and active regions
                      </Card.Title>
                      <div className="solar-card-content">
                        <Image
                          style={{ width: "100%", objectFit: "contain" }}
                          src="https://www.solen.info/solar/images/charmap512.jpg"
                          alt="Coronal holes and active regions"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} className="full-height">
                  <div className="solar-right-stack full-height">
                    <Card className="pb-1 pt-1 px-1 full-height solar-forecast-card">
                      <h6 className="solar-panel-header">Current / Forecast Solar Activity</h6>
                      <div className="solar-card-content">
                        <Image
                          title="Forecast Solar Activity"
                          src="https://www.sws.bom.gov.au/Images/Solar/Solar%20Conditions/Solar%20Activity%20Plot/solplot.gif"
                          style={{ width: "100%", objectFit: "contain" }}
                        />
                      </div>
                    </Card>
                    <Card className="pb-1 pt-1 px-1 full-height solar-sunspot-card">
                      <h6 className="solar-panel-header">Sunspot Analysis</h6>
                      <div className="solar-card-content">
                        <SolarWidget
                          details={{
                            radios: [
                              { name: "Daily", value: "0" },
                              { name: "Monthly", value: "1" },
                              { name: "Yearly", value: "2" },
                              { name: "Current year", value: "3" },
                              { name: "Forecast", value: "4" },
                            ],
                            src: [
                              `https://www.sidc.be/images/wolfjmms.png`,
                              `https://wwwbis.sidc.be/images/wolfmms.png`,
                              `https://wwwbis.sidc.be/silso/IMAGES/GRAPHICS/wolfaml2.png`,
                              `https://wwwbis.sidc.be/silso/DATA/EISN/EISNcurrent.png`,
                              `https://wwwbis.sidc.be/silso/IMAGES/GRAPHICS/prediKFSC.png`,
                            ],
                            type: "button",
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Card>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={6} className="full-height">
            <Card className="pb-1 pt-1 px-1 full-height solar-sdo-current-card">
              <h6 className="solar-panel-header" style={{ display: "flex", justifyContent: "space-between" }}>
                Solar Dynamics Observatory current image
                <a href="/" className="custom-btn__circular minus" aria-label="Close">
                  {" "}
                </a>
              </h6>
              <div className="solar-card-content">
                <SolarWidget
                  details={{
                    radios: [
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0171.jpg", value: "0" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_512_0193.jpg", value: "1" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0304.jpg", value: "2" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_HMIBC.jpg", value: "4" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_1600.jpg", value: "3" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0211.jpg", value: "5" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/f_304_211_171_2048.jpg", value: "6" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_1024_211193171.jpg", value: "7" },
                      { name: "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_HMIIC.jpg", value: "8" },
                    ],
                    src: [
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0171.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_512_0193.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0304.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_HMIBC.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_1600.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_0211.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/f_304_211_171_2048.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_1024_211193171.jpg",
                      "https://sdo.gsfc.nasa.gov/assets/img/latest/latest_2048_HMIIC.jpg",
                    ],
                    type: "image",
                  }}
                  style={{ height: "100%", margin: "auto" }}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}
